export const capitalizeFirstLetter = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export const formatTerminalCode = (word: string) => {
  return word.toUpperCase().replace(/\s/g, "");
};
